import { Component, OnInit } from '@angular/core';
import { AppService } from '../app.service';
import { environment } from "src/environments/environment";
import { Router} from "@angular/router";

declare var gtag;
declare var fbq;

@Component({
  selector: 'app-pagenotfound',
  templateUrl: './pagenotfound.component.html',
  styleUrls: ['./pagenotfound.component.css']
})
export class PagenotfoundComponent implements OnInit {

  constructor(private service:AppService, private router: Router) { }

  ngOnInit() {
    if(environment.production){
      this.service.sendEvents("Completpagenotfound", "pagenotfound", "PageNotFound");
  
      fbq('track', "CompletePageNotFound" , {
        content_type: "pagenotfound",
        content_title: this.router.url,
      });
    }

    this.service.setTitle('404 - Page Not Found');
    this.service.setMetaTags({ property: "og:title", content: '404 - Page Not Found' });
    this.service.setMetaTags({ name: "keywords", content: '404 - Page Not Found' });
    this.service.setMetaTags({ name: "description", content: 'Unfortunately the page you are looking for has been moved or deleted' });
    this.service.setMetaTags({ property: "og:description", content: 'Unfortunately the page you are looking for has been moved or deleted' });
  }

}
